import { render, staticRenderFns } from "./abondanedcart.vue?vue&type=template&id=345970e0&scoped=true"
import script from "./abondanedcart.vue?vue&type=script&lang=js"
export * from "./abondanedcart.vue?vue&type=script&lang=js"
import style0 from "./abondanedcart.vue?vue&type=style&index=0&id=345970e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345970e0",
  null
  
)

export default component.exports